import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// reducer import
import customizationReducer from "./customizationReducer";
import accountReducer from "./accountReducer";
import AppNavigationReducer from "./appNavigationReducer";
import notificationReducer from "./notificationReducer";
import tourReducer from "./tourSlice";
import errorReducer from "./errorReducer";
import filterReducer from "./filter";

// Persist Configs
const appNavigationPersistConfig = {
  key: "appNavigation",
  storage,
  keyPrefix: "berry-",
};

const filterPersistConfig = {
  key: "filter",
  storage,
  keyPrefix: "berry-",
};

const reducer = combineReducers({
  account: persistReducer(
    {
      key: "account",
      storage,
      keyPrefix: "berry-",
    },
    accountReducer
  ),
  customization: customizationReducer,
  appNavigation: persistReducer(
    appNavigationPersistConfig,
    AppNavigationReducer
  ),
  notifiHistory: notificationReducer,
  tour: tourReducer,
  error: errorReducer,

  filter: persistReducer(filterPersistConfig, filterReducer),
});

export default reducer;
